import React, { Fragment, useState } from 'react';
import NewDesign from 'components/NewDesign';
import { Popover, PopoverContent, PopoverTrigger } from 'shadcn/components/popover';
import { CommonIcons } from 'components/Icons';
import { Button } from 'shadcn/components/button';
import { cn } from 'helpers/css';
import { Separator } from 'shadcn/components/separator';

const ButtonDropdownComponent = (props) => {
  const {
    title,
    listDropDownItem = [],
    className,
    classNameDropdownMenu,
    disabled,
    color = 'primary',
    variant,
    hideArrow = false,
  } = props;
  const [dropdownOpen, setOpen] = useState(false);

  return (
    <Popover open={dropdownOpen} onOpenChange={setOpen}>
      <PopoverTrigger>
        <NewDesign.Button
          disabled={disabled}
          className={cn('tw-block', className)}
          variant={variant}
          color={color}
        >
          {title}{' '}
          {!hideArrow && (
            <CommonIcons.ArrowDown className='tw-inline-block !tw-mr-0 tw-ml-1 tw-translate-y-[1px]' />
          )}
        </NewDesign.Button>
      </PopoverTrigger>
      <PopoverContent className={cn('tw-flex tw-flex-col tw-max-w-max', classNameDropdownMenu)}>
        {listDropDownItem.map((el, index) => (
          <Fragment key={`${index}`}>
            <Button
              key={`${index}`}
              disabled={el.disabled}
              onClick={() => {
                setOpen(false);
                el.onClick && el.onClick();
              }}
              variant='ghost'
              className={cn(
                'hover:tw-rounded-none hover:tw-cursor-pointer hover:tw-bg-slate-200 dark:hover:tw-text-black tw-justify-start',
                el.className
              )}
            >
              {el.name}
            </Button>
            {el.divider && <Separator className='tw-my-1' />}
          </Fragment>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export default React.memo(ButtonDropdownComponent);
